import React from 'react';
import { Link } from 'react-router-dom';

/**
 * NotFound page component for 404 errors - Modern, beautiful, English version, CSS only
 */
const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-code">404</div>
      <h2 className="not-found-title">Page Not Found</h2>
      <p className="not-found-desc">
        The page you are looking for doesn&apos;t exist, may have been removed, renamed, or is temporarily unavailable.<br />
        Please check the URL or return to the homepage.
      </p>
      <Link to="/" className="not-found-home-btn">
        Back to Home
      </Link>
      <div className="not-found-illustration">
        <svg width="180" height="120" viewBox="0 0 180 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="90" cy="100" rx="70" ry="12" fill="#4a6da7" />
          <path d="M60 80 Q90 30 120 80" stroke="#4a6da7" strokeWidth="6" fill="none" />
          <circle cx="90" cy="60" r="10" fill="#e74c3c" />
        </svg>
      </div>
    </div>
  );
};

export default NotFound;